// @flow
import CentenaireSharePicture from 'components/centenaire/CentenaireSharePicture';
import { connect } from 'react-redux';

import type { StateType, DispatchType } from 'types/Actions';
import type { StateProps, DispatchProps } from 'components/centenaire/CentenaireSharePicture';

import { displayModal } from 'actions/modalActions';

export default connect(
  (state: StateType): StateProps => ({}),
  (dispatch: DispatchType): DispatchProps => ({
    displayModal: (modalObject: string, content: Object, force: boolean) =>
      dispatch(displayModal(modalObject, content, force))
  })
)(CentenaireSharePicture);
